import EntityType from "@mapmycustomers/shared/enum/EntityType";

import useDefaultSourceObjectKey from "@app/util/hook/useDefaultSourceObjectKey";
import useSourceObjectMessageArgs from "@app/util/hook/useSourceObjectMessageArgs";
import { SourceObjectMessageArgs } from "@app/util/ui";

// Message args for the org's default type of an entity, for texts that create a record
const useDefaultSourceObjectMessageArgs = (
  entityType: EntityType | undefined
): SourceObjectMessageArgs =>
  useSourceObjectMessageArgs(entityType, useDefaultSourceObjectKey(entityType));

export default useDefaultSourceObjectMessageArgs;
